<template>
  <div class="project-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "ProjectBase"
};
</script>

<style>
</style>